import React from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/scheduled";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";
import {message} from "antd";
import Divider from "../../components/Divider";


function Scheduled() {

    const {tableProps, refresh} = useAntTable(api.getSchedules, {})

    const {run: onExecute} = useRequest(api.executeSchedule, {
        manual: true, onSuccess: () => message.success("执行成功")
    })

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifySchedule,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '名称',
            dataIndex: 'description',
        },
        {
            title: 'Cron',
            dataIndex: 'cronExpression'
        },
        {
            title: '类',
            dataIndex: 'jobClassName'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: value => (value === -1) ? '停用' : '启用'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Divider>
                    <a onClick={() => setVisible(true, record)}>编辑</a>
                    <a onClick={() => onExecute(record.jobClassName)}>立即执行</a>
                </Divider>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} />
            <ModifyModal {...modalProps}/>
        </PageHeaderLayout>
    )
}

export default Scheduled
